import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'

import {
  FeedbackButton,
  FeedbackButtonContainer,
  FeedbackImage,
  FeedbackText,
} from './styles'

const LeaveFeedbackButton = ({lang, query}) => {
  const {t} = useTranslation('common')
  const [isSticky, setIsSticky] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY
      setIsSticky(offset > 100) // Adjust the offset value as needed
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <FeedbackButton
      isSticky={isSticky}
      href={`${
        process.env[`REACT_APP_FEEDBACK_URL_${lang.toUpperCase()}`]
      }?query=${query}`}
      aria-label={t('feedbackButton.ariaMessage')}
    >
      <FeedbackButtonContainer>
        <FeedbackImage />
        <FeedbackText>{t('feedbackButton.text')}</FeedbackText>
      </FeedbackButtonContainer>
    </FeedbackButton>
  )
}

export default LeaveFeedbackButton
